import { useEffect, useState } from 'react';
import {
  AccordionDetails,
  Typography,
  Container,
  Grid,
  Accordion,
  styled,
  Paper,
  useTheme,
  useMediaQuery,
  Box,
  InputAdornment,
  FormControl,
  TextField,
  AccordionSummary,
  CircularProgress,
} from '@mui/material';
import Page from '../components/Page';
import SearchIcon from '@mui/icons-material/Search';
import { useSelector } from 'react-redux';
import {
  getPreguntasList,
  getPreguntasStatus,
  getQuestions,
} from '../features/preguntas/preguntasSlice';
import { store } from '../store';
import AccordionIcon from '../assets/icons/accordion-icon';

const QuestionsWrapper = styled(Paper)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem 2rem 1rem 1rem',
}));

const QuestionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '.875rem',
  fontWeight: 600,
  letterSpacing: 0,
  color: theme.palette.grey[600],
}));

let delay: NodeJS.Timeout;

export default function PreguntasFrecuentes() {
  const theme = useTheme();

  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  const [searchWord, setSearchWord] = useState('');

  const preguntas = useSelector(getPreguntasList);
  const preguntasStatus = useSelector(getPreguntasStatus);

  useEffect(() => {
    if (delay) {
      clearTimeout(delay);
    }

    delay = setTimeout(() => {
      store.dispatch(getQuestions(searchWord));
    }, 250);
  }, [searchWord]);

  return (
    <Page>
      <Container>
        <Grid
          container
          padding={'1.875rem'}
          justifyContent="center"
          direction={desktop ? 'row' : 'column'}
        >
          <Grid item sm={8} sx={{ alignSelf: 'center' }}>
            <Box mb={3}>
              <Typography variant="subtitle1" mb="1rem">
                Preguntas Frecuentes
              </Typography>
              <FormControl sx={{ width: '100%' }} variant="standard">
                <TextField
                  id="filled-search"
                  placeholder="¿Con qué podemos ayudarte?"
                  variant="outlined"
                  type="search"
                  sx={{ width: '100%' }}
                  value={searchWord}
                  onChange={(text) => setSearchWord(text.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: preguntasStatus === 'loading'
                      ? <InputAdornment position="end">
                          <CircularProgress size={20} />
                        </InputAdornment>
                      : null
                  }}
                />
              </FormControl>
            </Box>
            <QuestionsWrapper>
              {
                preguntasStatus === 'loading' && preguntas.length == 0
                  ? <Box sx={{ width: '100%', textAlign: 'center' }}>
                      <CircularProgress size={40} />
                    </Box>
                  : null
              }
              {
                preguntasStatus === 'success' && preguntas.length == 0
                  ? <Typography>No se encontraron resultados para la busqueda</Typography>
                  : null
              }
              {
                preguntas.length > 0
                  ? preguntas.map(pregunta => (
                    <Accordion key={ pregunta.id }>
                      <AccordionSummary expandIcon={<AccordionIcon />}>
                        <QuestionTitle>{ pregunta.pregunta }</QuestionTitle>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography variant="body2">{ pregunta.respuesta }</Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))
                  : null
              }
            </QuestionsWrapper>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
